import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import DashboardPage from './pages/DashboardPage';
import ClientesPage from './pages/ClientesPage';
import SesionesPage from './pages/SesionesPage';
import BonosPage from './pages/BonosPage';
import AdminPage from './pages/AdminPage';
import Layout from './components/Layout';

import './App.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              } 
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="clientes" element={<ClientesPage />} />
              <Route path="sesiones" element={<SesionesPage />} />
              <Route path="bonos" element={<BonosPage />} />
              <Route path="admin" element={<AdminPage />} />
            </Route>

            {/* Catch all to root */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
